<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="status-card">
        <div class="status-card-title inf">PERIOD IN PROGRESS</div>
        <div class="status-card-description">
          <p>The current refund period is in progress.
            No refund has been offered because the refund period is not yet complete.</p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="status-card">
        <div class="status-card-title inf">UNDER NS REVIEW</div>
        <div class="status-card-description">
          <p>NS is reviewing shipments which may qualify for potential refund.
          </p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="status-card">
        <div class="status-card-title warn">REFUND OFFERED</div>
        <div class="status-card-description">
          <p>NS has offered your company a refund.
            If you do not accept or dispute the refund offer within two weeks,
            it will be automatically accepted.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col">
      <div class="status-card">
        <div class="status-card-title err">DISPUTED</div>
        <div class="status-card-description">
          <p>Your refund period was disputed and is being reviewed by a Contract Compliance Analyst.</p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="status-card">
        <div class="status-card-title progress">PAYMENT PROCESSING</div>
        <div class="status-card-description">
          <p>You have accepted the NS refund offer and the payment process has been initiated.</p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="status-card">
        <div class="status-card-title success">PAID</div>
        <div class="status-card-description">
          <p>Payment for your accepted refund has been fulfilled and payment details are available on the Refund page.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col">
      <div class="status-card">
        <div class="status-card-title support">NO PAYMENT DUE</div>
        <div class="status-card-description">
          <p>Refund period has ended and resulted in no refund.</p>
        </div>
      </div>
    </div>
    <div class="col">
    </div>
    <div class="col">
    </div>
  </div>
</div>
